import { Tag } from '@chakra-ui/react';
import React from 'react';

import { colors } from '~/packages/common-frontend/colors';
import { Typography } from '~/packages/common-frontend/components/Typography';

export const IdPill = ({ label, value }: { label: string; value: string }) => {
  return (
    <Tag
      backgroundColor="white"
      borderColor={colors.gray[100]}
      borderRadius="64px"
      borderWidth="1px"
      cursor="default"
      gap="0.5rem"
      p="8px 16px"
    >
      <Typography fontWeight="bold">{label}</Typography>
      <Typography>{value}</Typography>
    </Tag>
  );
};
